import { httpsCallable } from 'firebase/functions';
import type {
  AuditRecordPiiAccessRequest,
  AuditRecordPiiAccessResponse,
} from '@kawai/shared';
import { functions } from '../firebase.js';

/**
 * S-74: 顧客 PII 閲覧の監査記録 Callable のクライアント側ラッパ。
 *
 * 表示側（顧客一覧 / 顧客詳細）から fire-and-forget で呼ぶ。actorUid / tenantId /
 * impersonatedBy は Functions 側で claims から確定するため、ここでは kind / targetId /
 * count のみ送る。監査記録は補助目的で、失敗しても UI を壊さないよう例外を握り潰す。
 */
const auditRecordPiiAccessCallable = httpsCallable<
  AuditRecordPiiAccessRequest,
  AuditRecordPiiAccessResponse
>(functions, 'auditRecordPiiAccess');

export async function recordPiiAccess(
  req: AuditRecordPiiAccessRequest,
): Promise<void> {
  try {
    await auditRecordPiiAccessCallable(req);
  } catch {
    // 監査記録は best-effort。失敗は UI に伝播させない。
  }
}
